import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/es/servicios/farmacovigilancia/inteligencia-regulatoria")({
  head: () => buildRouteHead("/es/servicios/farmacovigilancia/inteligencia-regulatoria"),
  component: PVOffering,
});

